/**
 * Created by dmitry on 24.08.2026
 */

VIPRewardedWindow.prototype.getPerson = function () {
    const person = cleverapps.persons.choose("king", "hero");

    if (person) {
        return {
            role: person.role,
            emotion: "happy"
        };
    }
};
